import React, { useState } from "react";
import axiosClient from "../api/axiosClient";
import { useNavigate } from "react-router-dom";
import "../Register.css";


const Register = () => {
  const [formData, setFormData] = useState({
    phone_number: "",
    first_name: "",
    last_name: "",
  });
  const [message, setMessage] = useState("");
  const navigate = useNavigate();
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateInput = () => {
    if (!formData.first_name) {
      setMessage("Please enter first name");
      return false;
    }
    if (!formData.last_name) {
      setMessage("Please enter last name");
      return false;
    }
    if (!formData.phone_number) {
      setMessage("Please enter a phone number");
      return false;
    }
    if (formData.phone_number.length !== 10) {
      setMessage("Enter a 10 digit phone number");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("API_BASE_URL", process.env.REACT_APP_API_BASE_URL);
    if (!validateInput()) {
      return;
    }
    try {
      const response = await axiosClient.post("/user/", formData);
      if (response.data.message) {
        setMessage(response.data.message);
        // Navigate to VerifyOtp page and pass the phone number as state
        navigate("/verify", { state: { phoneNumber: formData.phone_number } });
      }
    } catch (error) {
      if (error.response && error.response.data) {
        if (error.response.data.phone_number) {
          setMessage("A user with this phone number already exists. Please log in.");
        } else {
          setMessage(error.response.data.message || "An error occurred. Please try again.");
        }
      } else {
        setMessage("Network error. Please check your connection and try again.");
      }
    }
  };

  const handleLoginRedirect = () => {
    navigate("/login"); // Redirect to the login/OTP verification page
  };

  return (
    <div className="page-container">
      <img src="/new_logo.png" alt="Logo" className="logo" />
      <h1 className="title">Register</h1>
      <form onSubmit={handleSubmit} className="form">
        <input
          type="text"
          name="phone_number"
          placeholder="Phone Number"
          value={formData.phone_number}
          onChange={handleInputChange}
          className="input_register"
          required
        />
        <input
          type="text"
          name="first_name"
          placeholder="First Name"
          value={formData.first_name}
          onChange={handleInputChange}
          className="input_register"
          required
        />
        <input
          type="text"
          name="last_name"
          placeholder="Last Name"
          value={formData.last_name}
          onChange={handleInputChange}
          className="input_register"
          required
        />
        <button type="submit" className="submit-button"> Register </button>
      </form>
      <br></br>
      <div className="regular">Already have an account? <button
        onClick={handleLoginRedirect}
        className="small-button">
         Login
      </button>
      </div>
      
      {message && <p className="error">{message}</p>}
    </div>
  );
};

export default Register;
